import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useContext, createContext } from 'react';
import { useMediaQueries } from 'seagull';
function useInnerMediaQuery(contextLoaded, disableMobile) {
    const { largerThanTablet, smallerThanTablet, isPortrait } = useMediaQueries();
    return useMemo(()=>({
            contextLoaded,
            isDesktop: disableMobile ? true : largerThanTablet,
            isMobile: disableMobile ? false : smallerThanTablet,
            isPortrait
        }), [
        contextLoaded,
        disableMobile,
        isPortrait,
        largerThanTablet,
        smallerThanTablet
    ]);
}
export const ResponsiveContext = /*#__PURE__*/ createContext({
    contextLoaded: false,
    isMobile: false,
    isDesktop: false,
    isPortrait: false
});
export function ResponsiveProvider(param) {
    let { children, disableMobile = false } = param;
    return /*#__PURE__*/ _jsx(ResponsiveContext.Provider, {
        value: useInnerMediaQuery(true, disableMobile),
        children: children
    });
}
export function useResponsive() {
    const context = useContext(ResponsiveContext);
    const defaultContext = useInnerMediaQuery(false, false);
    return context.contextLoaded ? context : defaultContext;
}
